'use client';

import { useState, useEffect } from 'react';

export function ClientOnly({ 
	children, 
	...delegated 
}: { 
	children: React.ReactNode 
}) {
	const [hasMounted, setHasMounted] = useState(false);

	useEffect(() => {
		setHasMounted(true);
	}, []);
	
	if (!hasMounted) {
		return null;
	}

	return (
		<div {...delegated}>
			{children}
		</div>
	);
}